exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe {\n  width: 350px;\n  height: 350px;\n  /* Track */\n  /* Handle */\n  /* Handle on hover */ }\n  .iframe ::-webkit-scrollbar {\n    width: 6px; }\n  .iframe ::-webkit-scrollbar-track {\n    border-radius: 10px; }\n  .iframe ::-webkit-scrollbar-thumb {\n    background: #3091f2;\n    border-radius: 10px; }\n  .iframe ::-webkit-scrollbar-thumb:hover {\n    background: #3091f2; }\n", ""]);

// exports
